import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import HotelContact from './HotelContact';

class HotelContactsView extends React.Component {
  render() {
    const hotel = this.props.hotel;
    const contacts = [];
    hotel.contacts.forEach((contact) => {
      contacts.push(
        <HotelContact
          key={contact.id}
          hotelId={hotel.id}
          contact={contact}
          addHotelContact={this.props.addHotelContact}
          removeHotelContact={this.props.removeHotelContact}
        />,
      );
    });
    return (
      <div>
        <h4 className="hotel-highlight">Hotel Contacts<Button onClick={this.props.handleEdit}>Add</Button></h4>
        {contacts}
      </div>
    );
  }
}
HotelContactsView.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  addHotelContact: PropTypes.func.isRequired,
  removeHotelContact: PropTypes.func.isRequired,
};
export default HotelContactsView;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelContactsView.js